/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-nested-ternary */
import { useWindowSize } from '@brands/hooks';
import { customStylesDashboard } from '@brands/Utils/customStyles';
import { Button } from '@mui/material';
import React, { FC, useMemo } from 'react';
import Modal, { Styles } from 'react-modal';

import closeICon from '../../Patient/components/closeIconSVG.svg';
import styles from './styles.module.scss';

export interface AddAdditionalInformationFormSubmit {
  notes: string;
  images: string[];
  caseId: string;
}

interface RemoveItemModalProps {
  isOpen: boolean;
  toggleModal: (value: boolean) => void;
  itemName: string;
  removeItem: () => Promise<void>;
}

const mobileCustomStylesDashboard: Styles = {
  ...customStylesDashboard,
  overlay: {
    ...(customStylesDashboard?.overlay || {}),
    backgroundColor: 'rgba(0, 0, 0, 0.25)',
    overflowY: 'scroll' as const,
    overflowX: 'hidden' as const,
  },
  content: {
    ...(customStylesDashboard?.content || {}),
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '320px',
    height: '268px',
    padding: '90px 16px 32px 16px',
    margin: '0',
    borderRadius: '0',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#fff',
  },
};

const customStylesDashboardDesktop: Styles = {
  ...customStylesDashboard,
  overlay: {
    ...customStylesDashboard.overlay,
  },
  content: {
    ...customStylesDashboard.content,
    flexDirection: 'column',
    width: '444px',
    padding: '55px 32px 32px',
    overflowY: 'auto',
    maxHeight: '850px',
    justifyContent: 'flex-start',
    backgroundColor: '#fff',
  },
};
const RemoveItemModal: FC<RemoveItemModalProps> = ({ isOpen, toggleModal, itemName, removeItem }) => {
  const screenSize = useWindowSize();
  const isMobile = useMemo(() => screenSize.width < 768, [screenSize.width]);

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={() => toggleModal(false)}
      style={isMobile ? mobileCustomStylesDashboard : customStylesDashboardDesktop}
      contentLabel="Modal"
      ariaHideApp={false}
    >
      <div className={styles.closeICon}>
        <img src={closeICon} onClick={() => toggleModal(false)} />
      </div>

      <div className={styles.removeItemContainer}>
        <div>
          <span
            className={`fs-unmask ${styles.removeModalHeader}`}
          >{`Are you sure you want to remove ${itemName}?`}</span>
          <span className={`fs-unmask ${styles.removeModalSubtile}`}>This action can’t be undone.</span>
        </div>
        <div>
          <Button
            variant="contained"
            className="fs-unmask"
            color="error"
            onClick={() => removeItem()}
            data-testid="remove-item-modal-remove"
          >
            Remove
          </Button>
          <Button
            variant="text"
            color="primary"
            className={`fs-unmask ${styles.cancel}`}
            onClick={() => toggleModal(false)}
          >
            Cancel
          </Button>
        </div>
      </div>
    </Modal>
  );
};

Modal.setAppElement('#root');

export default RemoveItemModal;
